export class Group {
    id: number;
    parent: {
        id: number;
        name: string;
    };
    name: string;
    type: string;
}